module.exports = __webpack_public_path__ + "static/media/USDT-logo.4d06ed03.png";